import { createContext, useContext } from "react";
import { Screen } from "@jugl-web/utils/utils/ScreenTransitionManager";
import {
  InstagramAccountModel,
  LiveChatAppAccountModel,
  TwilioAccountModel,
  WebChatBotAccountModel,
  WhatsappAgentModel,
} from "@jugl-web/rest-api";
import { ManageAccountsDrawerScreenToParametersMap } from "../types";

export interface ManageAccountsDrawerContextValue {
  isInboxModule: boolean;
  isManageAccountDrawerOpen:
    | Screen<ManageAccountsDrawerScreenToParametersMap>
    | undefined;
  openManageAccountDrawer: (
    screen: Screen<ManageAccountsDrawerScreenToParametersMap> | undefined
  ) => void;
  crmConfig?: {
    chatbot: WebChatBotAccountModel | null;
    instagram: InstagramAccountModel | null;
    twilio: TwilioAccountModel | null;
    whatsapp: WhatsappAgentModel | null;
    livechat: LiveChatAppAccountModel | null;
  };
  isCRMConfigFetching: boolean;
  isCRMConfigLoading: boolean;
  isCRMConfigError: boolean;
  refetchCRMConfig: () => void;
}

export const ManageAccountsDrawerContext = createContext<
  ManageAccountsDrawerContextValue | undefined
>(undefined);

export const useManageAccountsDrawer = () => {
  const context = useContext(ManageAccountsDrawerContext);
  if (!context) {
    throw new Error(
      "useManageAccountsDrawer must be used within a ManageAccountsDrawerProvider"
    );
  }
  return context;
};
